Ext.define('SA.model.createimport.File', {
    statics: {
        async fromCSV(file) {
            var {File, NullFile, UnreadableFile} = SA.model.createimport,
                {data, error} = (file && await SA.data.CSV.attemptParse(file)) || {};

            if (!file) {
                return new NullFile();
            }
            else if (error) {
                return new UnreadableFile(file.name);
            }

            return new File(file.name, data.headerNames, data.rows);
        }
    },

    constructor(fileName, headerNames, rows) {
        this.fileName = fileName || '';
        this.headerNames = headerNames || [];
        this.rows = rows || [];
    },

    getColumnCount() {
        return this.getHeaderNames().length;
    },

    getColumnValues(headerName) {
        var columnIndex = this.getHeaderNames().indexOf(headerName);

        return this.getRows().map(row => row[columnIndex]);
    },

    getContents() {
        return [this.getHeaderNames(), ...this.getRows()];
    },

    getFileName() {
        return this.fileName;
    },

    getHeaderNames() {
        return this.headerNames;
    },

    getRowCount() {
        return this.getRows().length;
    },

    getRows() {
        return this.rows;
    },

    isNull() {
        return this instanceof SA.model.createimport.NullFile;
    },

    isReadable() {
        return !this.isNull() && !this.isUnreadable();
    },

    isUnreadable() {
        return this instanceof SA.model.createimport.UnreadableFile;
    }
});